import {
  AppLayout,
  AppLayoutProps,
  Box,
  ColumnLayout,
  ColumnLayoutProps,
  Container,
  ContentLayout,
  Grid,
  Header,
  Link,
  SpaceBetween,
  TextContent,
  Badge,
  Button,
  Tabs,
} from "@cloudscape-design/components";
import { Mode } from "@cloudscape-design/global-styles";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import { link } from "fs";
import Series_Drivers from "../drivers";
import Series_Teams from "../teams";
import Series_Results from "../results";
import Series_Calendar from "../calendar";
import Series_Rules from "../trinations/rules";
import Series_Stats from "../stats";
import Series_Livery from "../livery";
import * as awsui from "@cloudscape-design/design-tokens";
import { useMediaQuery } from 'react-responsive';
import { useNavigate, useLocation } from "react-router-dom";
import { navigateFn } from "../../../routingHelper";
import SeriesNav from "../../../components/series-navbar/series-nav";
import GetSeriesContent from "../get-series-content";
import Rules from "./rules";
import Gallery from "./gallery";
import Series from "./series";
import Register from './register';
import Results from "./results";
import Calendar from "./calendar";
import DriversAndTeams from "./teams";
import Stats from "./stats";

export default function APJC_Series() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();
  const { 
    theme, setTheme, 
    density, setDensity,
    seriesContent, setSeriesContent,
  } = useContext(GlobalContext);
  
  const screenWidth_600 = useMediaQuery({query: "only screen and (max-width : 600px)"})
  const screenWidth_800 = useMediaQuery({query: "only screen and (max-width : 800px)"})
  const screenWidth_1000 = useMediaQuery({query: "only screen and (max-width : 1000px)"})

  return (
    <>
      <center>
        <div className="body-content">
          <ContentLayout
            header={
              <div className="series-header-container">
                <img 
                  className="series-header-img"
                  src="/images/apjc/apjc-header-light.png"
                />
              </div>
            }
          >
            <Container>
              <SeriesNav />
            </Container>
          </ContentLayout>
        </div>
        {GetSeriesContent(seriesContent, Series, Results, Calendar, Rules, DriversAndTeams, Stats, Gallery, Register, Results )}
      </center>
    </>
  );
}
